import React, { useMemo } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';

function Home() {
  const { user } = useAuth();

  // Check if user has access to statistics (ROE Visual employees only)
  const hasStatisticsAccess = useMemo(() => {
    if (!user) return false;

    const email = user.email?.toLowerCase() || '';
    const isRoeVisualEmail = email.endsWith('@roevisual.com');

    // Check if user authenticated via Azure SSO
    const isAzureUser = user.app_metadata?.provider === 'azure' ||
                        user.identities?.some(identity => identity.provider === 'azure');

    return isRoeVisualEmail || isAzureUser;
  }, [user]);

  return (
    <Container className="py-5 text-center">
      <h1>ROE Visual DB</h1>
      <p>Select an option below to proceed:</p>

      <Row className="mt-4">
        <Col></Col>
        <Col>
          <Link to="/search">
            <Button variant="primary" size="lg">
              New DB Search
            </Button>
          </Link>
        </Col>
        {hasStatisticsAccess && (
          <Col>
            <Link to="/statistics">
              <Button variant="success" size="lg">
                Statistics
              </Button>
            </Link>
          </Col>
        )}
        <Col></Col>
      </Row>

    </Container>
  );
}

export default Home;
